import React, {useEffect, useState} from 'react';

import {FormattedDate} from 'react-intl';

import './styles.scss';
import {IChatroomDialogue} from '../../redux/chatroom/interfaces';
import FavoriteButton from '../article-card/favorite-button';

type Props = {
  card: IChatroomDialogue;
  onClick: () => void;
  onChangeFavorite: () => void;
}

export const ChatroomCard = ({
  card,
  onClick,
  onChangeFavorite
}: Props): JSX.Element => {
  const [cardData, setCardData] = useState<IChatroomDialogue>(card);

  useEffect(() => {
    setCardData(card);
  }, [card]);

  function handleClick() {
    onClick();
  }

  function changeFavorite() {
    onChangeFavorite();
  }

  function renderBasicCard() {
    return <div className="chatroom-area">
      <div className="chatroom-area__card-place">
        <div className="chatroom-area__card">
          <div className="chatroom-area__title">
            <div className="chatroom-area__title-wrapper">
              <button className="chatroom-area__title__name" onClick={handleClick}>{cardData.userNick}</button>
              <button className="chatroom-area__title__text" onClick={handleClick}>{cardData.name}</button>
              <div className="chatroom-area__title__date">{cardData.userDate != null
                && <FormattedDate
                  value={cardData.userDate}
                  year="numeric"
                  month="long"
                  hour="numeric"
                  minute="numeric"
                  day="2-digit"
                />}</div>
            </div>
          </div>
        </div>
        <div className="chatroom-area__bottom">
          <div className="chatroom-area__bottom__favorite">
            <FavoriteButton favorite={cardData.favourite} changeFavorite={changeFavorite}/>
          </div>
        </div>
      </div>
    </div>;
  }

  return renderBasicCard();
};
